export const USERS = 'USERS'
export const TRANSACTIONS = 'TRANSACTIONS'
export const MAX_BID_CHANGES = 'MAX_BID_CHANGES'
export const PARTY_ROLE_CHANGES = 'PARTY_ROLE_CHANGES'
export const USER_CHANGES = 'USER_CHANGES'
export const CLIENTS = 'CLIENTS'
export const CLIENTS_ROLES = 'CLIENTS_ROLES'
export const ENDPOINTS = 'ENDPOINTS'
export const ORGANIZATION = 'ORGANIZATION'
export const ENDPOINTS_ALL = 'ENDPOINTS_ALL'
export const INVITATIONS = 'INVITATIONS'
export const TINY_URLS = 'TINY_URLS'
export const USER_REGISTERED_LISTINGS = 'USER_REGISTERED_LISTINGS'
export const USER_REGISTERED_LISTING_REMOVE = 'USER_REGISTERED_LISTING_REMOVE'
export const USER_LISTINGS_BANNED_FROM_BIDDING =
  'USER_LISTINGS_BANNED_FROM_BIDDING'
export const MORPHEUS_LOGS = 'MORPHEUS_LOGS'
export const ORGANIZATION_MEMBERS = 'ORGANIZATION_MEMBERS'
export const COMMUNICATIONS = 'COMMUNICATIONS'
export const ORGANIZATION_CHANGES = 'ORGANIZATION_CHANGES'

// Schedule (events/venues)
export const VENUE_TEMPLATES = 'VENUE_TEMPLATES'
export const EVENT_TEMPLATES = 'EVENT_TEMPLATES'
export const EVENT_TEMPLATES_FORM = 'EVENT_TEMPLATES_FORM'
export const EVENT_FORM_EVENT_TEMPLATES = 'EVENT_FORM_EVENT_TEMPLATES'
export const EVENT_FORM_VENUE_TEMPLATES = 'EVENT_FORM_VENUE_TEMPLATES'
export const EVENTS = 'EVENTS'
export const VENUES = 'VENUES'
export const VENUE_TEMPLATE_CHANGES = 'VENUE_TEMPLATE_CHANGES'
export const EVENT_CHANGES = 'EVENT_CHANGES'
export const VENUE_CHANGES = 'VENUE_CHANGES'
